import React, { useState } from "react";
import styles from "./index.module.css";
import success from "../assets/success.png";
import android from "../assets/android.png";
import apple from "../assets/apple.png";
import arrow_right_up from "../assets/arrow_right_up.png";
import copy_success from "../assets/copy_success.png";
import app_success from "../assets/app_success.png";
import ReferralInfo from "../CheckoutPage/ReferralInfo";
import ReferralForm from "../CheckoutPage/ReferralForm";
import ReferralSuccess from "../CheckoutPage/ReferralSuccess";

const SuccessPage = ({
  amountPaid,
  dateAndTime,
  appStoreLink,
  playStoreLink,
  referralLink,
  bannerImg,
  referralCode,
  parentId,
}) => {
  const [isCopied, setIsCopied] = React.useState(false);
  const [showReferralSuccess, setShowReferralSuccess] = useState(false);

  const handleReferralFormSubmit = () => {
    setShowReferralSuccess(true);
  };

  const shareButtons = [
    {
      icon: apple,
      type: "iOS",
      link: appStoreLink,
    },
    {
      icon: android,
      type: "Android",
      link: playStoreLink,
    },
  ];

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const handleCopyText = () => {
    navigator.clipboard.writeText(referralLink);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  const openReferralPolicy = () => {
    window.open(
      "https://cy-assets.s3.ap-south-1.amazonaws.com/referral-policy+/referral_policy_oct_23.pdf"
    );
  };

  const handleOpenAppStore = (link) => {
    if (!link) return;

    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={styles.container}>
      <div className={styles.successHeadingContainer}>
        <img src={success} alt="success" className={styles.successIcon} />
        <p className={styles.successPaymentText}>Payment successful!</p>
      </div>
      <div className={styles.detailsContainer}>
        <div className={styles.details}>
          <p className={styles.detailsTitle}>Amount paid</p>
          <p className={styles.detailsSubtitle}>{amountPaid}</p>
        </div>
        <div className={styles.details}>
          <p className={styles.detailsTitle}>Date</p>
          <p className={styles.detailsSubtitle}>{formatDate(dateAndTime)}</p>
        </div>
      </div>
      <div className={styles.appStoreLinkContainer}>
        <div className={styles.appStoreLinkInfoContainer}>
          <p className={styles.appStoreLinkTitle}>What's next?</p>
          <p className={styles.appStoreLinkSubtitle}>
            Complete your onboarding to schedule your live classes by
            downloading the Codeyoung app.
          </p>
        </div>
        <div className={styles.shareButtonContainer}>
          {shareButtons.map((item, index) => {
            return (
              <div
                onClick={() => handleOpenAppStore(item?.link)}
                className={styles.shareButton}
                key={index}
              >
                <img
                  src={item?.icon}
                  alt={item?.type}
                  className={styles.shareIcon}
                />
                <p className={styles.downloadText}>
                  Download for{" "}
                  <span className={styles.downloadTypeText}>{item?.type}</span>
                </p>
                <img
                  src={arrow_right_up}
                  alt={"arrow_right_up"}
                  className={styles.arrowIcon}
                />
              </div>
            );
          })}
        </div>
        <img src={app_success} alt="app_img" className={styles.appImage} />
      </div>
      <ReferralSuccess
        open={showReferralSuccess}
        onClose={() => setShowReferralSuccess(false)}
      />

      <div className={styles.referralDetailsContainer}>
        <img
          src={bannerImg?.web}
          className={styles.referralDetailsImageWeb}
          alt="Referral"
        />
        <img
          src={bannerImg?.mobile}
          className={styles.referralDetailsImageMobile}
          alt="Referral"
        />
        <div className={styles.referralDetailsDivider} />
        <div className={styles.referralDetailsTop}>
          <ReferralInfo />
          <h2 className={styles.referralWorksHeading}>
            See how referral works
          </h2>
          <ReferralForm
            onSubmitted={handleReferralFormSubmit}
            referralCode={referralCode}
            parentId={parentId}
          />
        </div>
        <p className={styles.referralFormTitle}>
          Tell a friend about Codeyoung and{" "}
          <span className={styles.highlight}>earn rewards</span> when they sign
          up!
        </p>
      </div>
    </div>
  );
};

export default SuccessPage;
